import React from 'react';

interface TypingIndicatorProps {
  /**
   * Name of the person typing
   */
  userName: string;

  /**
   * Avatar URL (optional)
   */
  avatar?: string;
}

/**
 * TypingIndicator Component
 * Shows animated "User is typing..." indicator like Slack
 */
const TypingIndicator: React.FC<TypingIndicatorProps> = ({ userName, avatar }) => {
  return (
    <div className="flex items-start gap-3 px-4 py-2 animate-fadeIn">
      {/* Avatar */}
      {avatar ? (
        <img
          src={avatar}
          alt={userName}
          className="w-10 h-10 rounded-lg object-cover flex-shrink-0"
        />
      ) : (
        <div className="w-10 h-10 rounded-lg bg-[#015FA6] flex items-center justify-center flex-shrink-0">
          <span className="font-manrope font-semibold text-base text-white">
            {userName.charAt(0).toUpperCase()}
          </span>
        </div>
      )}

      {/* Typing indicator */}
      <div className="flex flex-col gap-1">
        <span className="font-manrope font-normal text-xs text-[#757575]">
          {userName} is typing...
        </span>
        <div className="flex items-center gap-1 bg-white rounded-2xl px-4 py-3 shadow-sm">
          <div className="flex items-center gap-1">
            <div className="w-2 h-2 bg-[#757575] rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
            <div className="w-2 h-2 bg-[#757575] rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
            <div className="w-2 h-2 bg-[#757575] rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
